<template>
  <div ref="parent" class="ellipsis">
    {{ ellipsisText }}
  </div>
</template>

<script>
export default {
  name: 'TextMiddleEllipsis',
  props: {
    text: {
      type: String,
      default: '',
    },
    maxRow:{
      type: Number,
      default: 1
    },
    endOffset: {
      type: Number,
      default: 7,
    }
  },
  data() {
    return {
      ellipsisText: '',
    }
  },
  mounted() {
    this.ellipsis()
    window.addEventListener('resize', this.ellipsis)
  },
  beforeUnmount() {
    window.removeEventListener('resize', this.ellipsis)
  },
  methods: {
    ellipsis() {
      const maxRow = this.maxRow
      const parentWidth = this.getActualElementWidth()
      const realWidth = this.getActualWidthOfChars(this.text)
      const lastCharWidth = this.getActualWidthOfChars(this.text[this.text.length - 1]) // 1文字分の余裕をもたせておく
      const noEllipsisWidth = parentWidth * maxRow - lastCharWidth


      if(noEllipsisWidth < realWidth) {
        const SEPARATOR = '...'
        const rightPart = this.text.slice(this.text.length - this.endOffset)
        const rightPartWidth = this.getActualWidthOfChars(SEPARATOR) + this.getActualWidthOfChars(rightPart)

        let availableLeftWidth = Math.round(noEllipsisWidth - rightPartWidth)
        let final = ''
        let charIndex = 0
        while (availableLeftWidth > 0) {
          const char = this.text[charIndex]
          let charWidth = this.getActualWidthOfChars(char)

          if (availableLeftWidth - charWidth < 0) break

          final += char
          availableLeftWidth -= charWidth
          charIndex += 1
        }

        final += `${SEPARATOR}${rightPart}`
        this.ellipsisText = final

      } else if(realWidth < parentWidth) {
        // 1行表示
        this.ellipsisText = this.text
        const parent = this.$refs.parent
        parent.style.height = `${this.getActualHeightOfChars(this.text) * maxRow}px` // 1行で表示できる場合もmaxRow分の高さを設定する
      } else {
        this.ellipsisText = this.text
      }
    },
    getActualElementWidth() {
      const BORDER_BOX = 'border-box'

      const parent = this.$refs.parent
      const { boxSizing, borderWidth } = window.getComputedStyle(parent)
      const { width } = parent.getBoundingClientRect()

      return (parseInt(borderWidth) > 0 && boxSizing !== BORDER_BOX) ? width - parseInt(borderWidth) * 2 : width
    },
    getSpanBoundingClientRect(chars){
      const span = document.createElement('span')
      span.innerText = chars
      span.style.position = 'fixed'
      span.style.top = '-777px'
      document.body.appendChild(span)
      const rect = span.getBoundingClientRect()
      document.body.removeChild(span)
      return rect
    },
    getActualHeightOfChars(chars) {
      const { height } = this.getSpanBoundingClientRect(chars)
      return height
    },
    getActualWidthOfChars(chars) {
      const { width } = this.getSpanBoundingClientRect(chars)
      return width
    }
  }
}
</script>

<style lang="scss" scoped>
.ellipsis {
  word-break: break-all;
}
</style>